import { Children } from 'react';

import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

import de from './de.json';
import en from './en.json';
import ToggleLocale from './ToggleLocale';

const messages = {
    en,
    de
};

const mapStateToProps = ({ intl }) => ({
    ...intl
});

const mapDispathToProps = () => ({});

const IwIntlProvider = (props) => {
    const { ready, children, locale, language } = props;

    if (!ready) {
        return null;
    }

    return (
        <>
            <IntlProvider locale={locale} messages={messages[language]}>
                {Children.only(children)}
            </IntlProvider>
            <ToggleLocale />
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispathToProps)(IwIntlProvider);
